<template>
<div>
  <transition name="fade">
    <div class="blackcover" :style="{'background-color':isBackgroundTransparent?'transparent':'rgba(0, 0, 0,.7)'}" v-if="coverVisible"></div>
  </transition>
  <div class="ui-alertbox">
    <transition name="scale">
      <div v-if="visible">
        <div class="alertbox">
          <div class="alert-title">{{title}}</div>
          <p class="ui-alertbox-desc">
            {{content}}
          </p>
          <div class="alert-btn box f-border-top-line-gray">
            <div class="cencel" @click="close(1)" v-if="cancel">{{cancel}}</div>
            <div class="ok" @click="close(2)">{{confirm}}</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</div>
</template>
<script>
export default {
  data() {
    return {
      coverVisible: false,
      visible: false,
      isBackgroundTransparent: false
    }
  },
  methods: {
    close(index) {
      this.visible = false
      this.coverVisible = false
      if (typeof this.onHide === 'function') this.onHide(index)
      this.$el.addEventListener('webkitAnimationEnd', () => {
        this.$destroy(true)
        this.$el.parentNode.removeChild(this.$el)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/*background:rgba(0,0,0,.26);*/

.blackcover {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10000;
}

.ui-alertbox {
  width: 100%;
  position: fixed;
  left: 0;
  top: 50%;

  text-align: center;
  -webkit-transform: translate3d(0, -50%, 0);
  -moz-transform: translate3d(0, -50%, 0);
  -o-transform: translate3d(0-50%, 0);
  transform: translate3d(0, -50%, 0);
  z-index: 10001;
}

.ui-alertbox .alertbox {
  max-width: 75%;
  min-width: 66%;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0 0 2px #b1b1b1;
  border-radius: 4px;
  display: inline-block;
}

.ui-alertbox .alert-title {
  line-height: 1.4em;
  padding: 14px 8px 0;
  font-size: 16px;
  color: #333;
}

.ui-alertbox .ui-alertbox-desc {
  font-size: 14px;
  color: #666;
  padding: 14px 14px 16px 14px;
  line-height: 1.5em;
  word-break: break-all;
}

.ui-alertbox .alert-btn {
  display: flex;
  line-height: 3em;
  font-size: 16px;
  color: #666;
}

.ui-alertbox .alert-btn>div {
  flex:1;
  /*width: 100%;*/
}

.ui-alertbox .alert-btn>div:last-child {
  color: #5264cc;
}

.ui-alertbox .alert-btn>div:nth-of-type(2) {
  position: relative;
  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 20%;
    width: 1px;
    height: 60%;
    background: #eee;
    transform: scale(0.5,1);
  }
}

.box {
  display: -webkit-box;
  display: flex;
}

.scale-enter-active {
  animation: scaleIn .4s ease;
}

.scale-leave-active {
  animation: scaleOut .3s ease;
}

.fade-enter-active {
  animation: fadein .6s ease;
}

@keyframes scaleIn {
  from {
    transform: scale(.5);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes scaleOut {
  from {
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: scale(1.1);
    opacity: 0;
  }
}
</style>
